import cn from 'clsx';
import { CSSProperties } from 'react';
import { makeStyles } from '@mui/styles';
import { nextMonday } from 'date-fns/fp';
const useStyles = (neon) =>
  makeStyles({
    cbutton: {
      border: `solid 2px ${neon} !important`,
      '&:hover': {
        border: 'solid 2px transparent !important',
        background: '#FF46FF !important',
        color: 'black !important',
      },
    },
  });

const loader = (
  <svg
    className="w-5 h-5 mr-3 -ml-1 text-black animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

type color = CSSProperties['color'];

type BorderSize = {
  height: CSSProperties['height'];
  width: CSSProperties['width'];
  backgroundColor?: color;
};

export interface ButtonMightyProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  disabled?: boolean;
  text: string;
  width?: CSSProperties['width'];
  icon?: React.ImgHTMLAttributes<HTMLImageElement>['src'];
  verticalBorderSize?: BorderSize;
  horizontalBorderSize?: BorderSize;
  height?: CSSProperties['height'];
  borderColor?: color;
  color?: color;
  margin?: CSSProperties['margin'];
  border?: CSSProperties['border'];
  textColor?: color;
  neon?: string;
}

function ButtonMighty({
  className,
  loading = false,
  disabled = false,
  text,
  width = 'full',
  neon,
  icon,

  color = '#8052FF',
  borderColor = '#8052FF',
  verticalBorderSize = {
    height: 10,
    width: 30,
    backgroundColor: borderColor,
  },
  horizontalBorderSize = {
    height: 55,
    width: 10,
    backgroundColor: borderColor,
  },
  height = 55,
  margin = '15px 0px 15px 0px',
  border = 0.995,
  textColor = 'white',
  style = {},
  ...buttonProps
}: ButtonMightyProps): React.ReactElement {
  const classes = useStyles(neon)();
  if (!verticalBorderSize.backgroundColor) {
    verticalBorderSize = {
      ...verticalBorderSize,
      backgroundColor: borderColor,
    };
  }
  if (!horizontalBorderSize.backgroundColor) {
    horizontalBorderSize = {
      ...horizontalBorderSize,
      backgroundColor: borderColor,
    };
  }

  return (
    <div
      className={cn('relative', className)}
      style={{
        width,
        minWidth: 200,
        margin: '0 auto',
      }}
    >
      {!neon && (
        <div>
          {' '}
          <div
            className="absolute left-0 pointer-events-none"
            style={horizontalBorderSize}
          />
          <div
            className="absolute top-0 left-0 pointer-events-none"
            style={verticalBorderSize}
          />
          <div
            className="absolute bottom-0 left-0 pointer-events-none"
            style={verticalBorderSize}
          />
          <div
            className="absolute right-0 pointer-events-none"
            style={horizontalBorderSize}
          />
          <div
            className="absolute top-0 right-0 pointer-events-none"
            style={verticalBorderSize}
          />
          <div
            className="absolute bottom-0 right-0 pointer-events-none"
            style={verticalBorderSize}
          />
        </div>
      )}

      <button
        className={cn(
          'w-full focus:outline-none flex items-center justify-center uppercase text-center px-8 lg:px-8 xl:px-12 text-lg',
          {
            'cursor-not-allowed': disabled,
            [classes.cbutton]: neon,
          }
        )}
        disabled={disabled}
        style={{
          backgroundColor: neon ? 'transparent' : color,
          height,
          margin,
          border,
          color: neon || textColor,
          opacity: loading ? 0.9 : 1,
          ...style,
        }}
        {...buttonProps}
      >
        {loading ? (
          loader
        ) : (
          <>
            {icon !== undefined && <img className="mr-2" src={icon} />}
            {text}
          </>
        )}
      </button>
    </div>
  );
}

export default ButtonMighty;
